// src/ui/screens/verifications/PendingVerificationPage.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';

const COLORS = {
  orange: '#FF8C08',
  bg: '#08090B',
  card: '#23262C',
};

// ── PendingVerificationPage ──────────────────────────────────────────────────

export const PendingVerificationPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-filatom-bg">
      {/* Top Bar */}
      <div className="pt-safe-top px-3 pb-1">
        <div className="flex items-center">
          <button
            onClick={handleGoBack}
            className="w-10 h-10 rounded-full flex items-center justify-center border border-white/10"
            style={{ backgroundColor: COLORS.card }}
          >
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="flex flex-col items-center max-w-sm w-full">
          {/* Icon */}
          <div
            className="w-25 h-25 rounded-full flex items-center justify-center"
            style={{ backgroundColor: `${COLORS.orange}1F` }}
          >
            <svg className="w-12 h-12 text-filatom-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h2 className="text-white text-2xl font-bold mt-6 text-center">
            Verification Pending
          </h2>

          <p className="text-white/70 text-sm text-center mt-3 leading-relaxed">
            Your seller verification is being reviewed by our team.
            <br /><br />
            This usually takes 24-48 hours. You'll be notified once your account is verified.
          </p>

          {/* Info Box */}
          <div
            className="w-full mt-8 p-4 rounded-xl flex items-center gap-3"
            style={{ backgroundColor: COLORS.card }}
          >
            <svg className="w-5 h-5 text-filatom-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="flex-1 text-white/60 text-xs">
              You'll be able to list properties once your verification is approved.
            </p>
          </div>

          {/* Go Back Button */}
          <button
            onClick={handleGoBack}
            className="w-full h-12 mt-8 rounded-xl text-filatom-primary font-semibold text-sm border border-filatom-primary"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingVerificationPage;